import { render, staticRenderFns } from "./AlgoliaListTable.vue?vue&type=template&id=8bf169a6"
import script from "./AlgoliaListTable.vue?vue&type=script&lang=js"
export * from "./AlgoliaListTable.vue?vue&type=script&lang=js"
import style0 from "./AlgoliaListTable.vue?vue&type=style&index=0&id=8bf169a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports